import { questionCheckResultContext } from ".";

export const QuestionCheckResultProvider = questionCheckResultContext.Provider;